import React from "react";
import Link from "next/link";

interface LegalFooterProps {
    /** Visual variant: "dark" for use on dark brand backgrounds (default). */
    variant?: "dark" | "light";
    className?: string;
}

/**
 * Minimal public legal footer linking the Privacy Policy and Subprocessors pages.
 * Used on the welcome and sign-in screens so an external pilot partner can reach
 * the legal pages before signing in (LG-3).
 */
export function LegalFooter({ variant = "dark", className = "" }: LegalFooterProps) {
    const linkClass =
        variant === "dark"
            ? "text-white/40 hover:text-white/70 transition-colors"
            : "font-semibold text-ink-3 hover:text-ink transition-colors";

    return (
        <footer className={`flex items-center justify-center gap-3 text-xs ${className}`}>
            <Link href="/privacy" className={linkClass}>
                Privacy
            </Link>
            <Link href="/subprocessors" className={linkClass}>
                Subprocessors
            </Link>
        </footer>
    );
}
